import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
export class ConditionsSortable extends ConditionRegistryCategory {
    label = 'Sortable';
    constructor(parent) {
        super(parent);
        super.init();
    }
    SortableItemisDragging = () => new ConditionRegistryItem({
        eval: ({ sortableItem }) => !!sortableItem && sortableItem.isDragging,
    });
    SortableItemisInAnyCorrectPlace = () => new ConditionRegistryItem({
        eval: ({ sortableItem }) => !!sortableItem && sortableItem.itemUI.isItemInAnyCorrectPlace,
    });
    SortableItemIsInOtherDroppableAndWrongPlace = () => new ConditionRegistryItem({
        eval: ({ sortableItem }) => !!sortableItem && sortableItem.itemUI.isItemInOtherDroppableAndWrongPlace,
    });
    SortableIsCorrect = () => new ConditionRegistryItem({
        eval: ({ questionSortable }) => questionSortable.sortableUI.isSortableCorrect,
    });
    SortableIsWrong = () => new ConditionRegistryItem({
        eval: ({ questionSortable }) => questionSortable.sortableUI.isSortableWrong,
    });
}
